import React from 'react';
import { INPUT_STATE } from '@/shared/components/form/input/inputStyles';

interface DigitInputProps {
    index: number;
    value: string;
    onChange: (value: string, index: number) => void;
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
    onBlur: () => void;
    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => void;
    inputRef: (el: HTMLInputElement | null, index: number) => void;
}

export const MfaInput: React.FC<DigitInputProps> = ({
    index,
    value,
    onChange,
    onKeyDown,
    onBlur,
    onPaste,
    inputRef,
}) => {
    return (
        <input
            type="text"
            maxLength={1}
            value={value}
            ref={(el) => inputRef(el, index)}
            onChange={(e) => onChange(e.target.value, index)}
            onKeyDown={(e) => onKeyDown(e, index)}
            onBlur={onBlur}
            onPaste={onPaste}
            className={`w-12 h-16 text-center text-2xl border-2 rounded-xl
        focus:outline-none focus:ring-2 ${INPUT_STATE.default}
        transition-transform duration-300 hover:scale-110`}
        />
    );
};
